var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dao-hang'),_c('zhong'),_c('router-view',{key:_vm.$route.path + _vm.$route.query.t}),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }